export default __webpack_public_path__ + "static/media/waiting-list-skip.2c5896a0.png";